export default __webpack_public_path__ + "static/media/face_1_45.e0de5839.png";